export default {
  dataModel: {
    types: [
      'pair:Type',
      'pair:PersonType',
      'pair:PlaceType',
      'pair:EventType',
      'pair:OrganizationType',
      'cdlt:CourseType',
      'cdlt:PathType',
      'cdlt:OfferAndNeedType'
    ],
    fieldsMapping: {
      title: 'pair:label'
    }
  },
};
